import React from 'react'
import {
  BrowserView,
  CustomView,
  isDesktop
} from 'react-device-detect'

export default function BrowserViewGlobal({ children, className = null }) {
  return (
    <BrowserView className={className}>
      {children}
    </BrowserView>
  )
}
